import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CarCard, CarCheckoutPickupDropoff } from "@tenant/cars";
import { CarPickupDropoffLocation } from "@tenant/cars";
import { Dialog, DialogTrigger, DialogContent } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarCheckoutCard.module.scss";
import type { VehicleAvailabilityWithSupplier } from "~core-cars/store";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export type CarCheckoutCardProps = {
  car: VehicleAvailabilityWithSupplier;
  dateRange?: { pickupDate: string; dropoffDate: string };
} & PlatformComponentProps;

const COMPONENT_KEY = CoreCarsComponent.CarCheckoutCard;

export const CarCheckoutCard = ({
  className,
  children,
  car,
  dateRange,
}: CarCheckoutCardProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  const isSameLocation =
    car.pickUp.coordinates.lat === car.dropOff.coordinates.lat &&
    car.pickUp.coordinates.lon === car.dropOff.coordinates.lon;

  return (
    <div className={clsx(block, className)}>
      <CarCard className={cn("card")} car={car}>
        {dateRange != null ? (
          <div className={cn("pickup-dropoff")}>
            <CarCheckoutPickupDropoff
              titles={{
                pickupTitle: t("checkout.cars.locationCard.pickupTitle"),
                dropoffTitle: t("checkout.cars.locationCard.dropoffTitle"),
              }}
              dateRange={dateRange}
              addresses={{
                pickupAddress: car.pickupLocationName,
                dropoffAddress: isSameLocation
                  ? car.pickupLocationName
                  : car.dropOff.address,
              }}
            />
            <Dialog>
              <DialogTrigger asChild>
                <button className={cn("location-button")} type="button">
                  {t("checkout.cars.locationCard.button")}
                </button>
              </DialogTrigger>
              <DialogContent title={t("core-cars.locationCard.title")}>
                <CarPickupDropoffLocation
                  car={car}
                  className={cn("dialog-content")}
                />
              </DialogContent>
            </Dialog>
          </div>
        ) : null}
        {children}
      </CarCard>
    </div>
  );
};
